import { RestResource } from "./common"
import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"

export enum EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE {
  EVENT_CONTRACTS = "Event Contracts",
}

export enum EXTERNAL_ACCOUNT_ELIGIBILITY {
  ELIGIBLE = "Eligible",
  INELIGIBLE = "Ineligible",
  REQUIREMENTS_MISSING = "Requirements Missing",
}

export enum EXTERNAL_ACCOUNT_STATUS {
  ACTIVE = "Active",
  CLOSED = "Closed",
  PENDING = "Pending",
}

export enum EXTERNAL_ACCOUNT_ENROLLMENT_TYPE {
  REGISTRATION_FUTURES = "Registration Futures",
  EVENT_CONTRACTS_KALSHI = "Kalshi Event Contracts",
}

export enum EXTERNAL_ACCOUNT_ENROLLMENT_STATUS {
  ACTIVE = "Active",
  CLOSED = "Closed",
  PENDING = "Pending",
  PENDING_AGREEMENT = "Pending Agreement",
}

export class ExternalAccountEnrollment {
  enrollmentType?: EXTERNAL_ACCOUNT_ENROLLMENT_TYPE
  status?: EXTERNAL_ACCOUNT_ENROLLMENT_STATUS
}

export const EXTERNAL_ACCOUNT_ENROLLMENT_DESER: SchemaDeSer<ExternalAccountEnrollment> =
  new SchemaDeSerBuilder(ExternalAccountEnrollment)
    .ofString("enrollmentType")
    .ofString("status")
    .toDeSer()

export class ClearingExternalAccount {
  accountNumber = ""
  assetClassScope: EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE[] = []
  enrollments: ExternalAccountEnrollment[] = []
  externalAccountNumber?: string
  externalFirm?: string
  status?: EXTERNAL_ACCOUNT_STATUS
  externalId?: string

  hasAssetClass(scope: EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE): boolean {
    return this.assetClassScope.includes(scope)
  }
}

export const EXTERNAL_ACCOUNT_DESER: SchemaDeSer<ClearingExternalAccount> =
  new SchemaDeSerBuilder(ClearingExternalAccount)
    .ofString("accountNumber")
    .ofPrimitiveArray("assetClassScope")
    .ofArray(
      "enrollments",
      EXTERNAL_ACCOUNT_ENROLLMENT_DESER,
      ExternalAccountEnrollment
    )
    .ofString("externalAccountNumber")
    .ofString("externalFirm")
    .ofString("status")
    .ofString("externalId")
    .toDeSer()

export class ExternalAccountEligibility extends RestResource {
  assetClassScope = ""
  status?: EXTERNAL_ACCOUNT_ELIGIBILITY
  requirements: string[] = []
  reason?: string

  get isEligible() {
    return this.status === EXTERNAL_ACCOUNT_ELIGIBILITY.ELIGIBLE
  }

  get isIneligible() {
    return this.status === EXTERNAL_ACCOUNT_ELIGIBILITY.INELIGIBLE
  }

  get isRequirementsMissing() {
    return this.status === EXTERNAL_ACCOUNT_ELIGIBILITY.REQUIREMENTS_MISSING
  }
}

export const EXTERNAL_ACCOUNT_ELIGIBILITY_DESER: SchemaDeSer<ExternalAccountEligibility> =
  new SchemaDeSerBuilder(ExternalAccountEligibility)
    .ofString("assetClassScope")
    .ofString("id")
    .ofString("reason")
    .ofString("status")
    .ofPrimitiveArray("requirements")
    .toDeSer()
